export const capitalize = (str) => {
  if(str) {

    const lower = str.toLocaleLowerCase()
    return str.charAt(0).toUpperCase()+lower.slice(1)
  }

  return ''
}